import { Footer} from '../container';
import PageHero from "../components/PageHero/PageHero";
import aboutBg from "../assets/bgimage.jpg";
export default function ContactPage() {

  return <>
  <PageHero title="Contact" bgImage={aboutBg} />
  <Footer /></>;
}
